import { IObject } from "@/objects/Index";
import baseService from "@/utils/baseService";

/**
 * 获取用户信息
 * @returns 
 */
function getUserInfo() {
    return baseService.get('app/user/userInfo')
}

/**
 * 修改用户信息 
 * @returns 
 */
function editUserInfo(body:IObject, headers?:IObject) {
    return baseService.post('app/user/editUserInfo', body, headers)
}

export {
    getUserInfo,
    editUserInfo
}